import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const supplierBookingReportsQuery = graphql(`
  query SupplierBookingReports(
    $supplierId: ID
    $year: Int
    $month: Int
    $page: Int
    $first: Int!
    $orderBy: [OrderByClause!]
  ) {
    supplierBookingReports(
      supplier_id: $supplierId
      year: $year
      month: $month
      page: $page
      first: $first
      orderBy: $orderBy
    ) {
      data {
        id
        month
        year
        pdf_url
        excel_url
        created_at
        supplier {
          id
          name
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

export type SupplierBookingReportResult = ResultOf<
  typeof supplierBookingReportsQuery
>["supplierBookingReports"]["data"][number];

export const resendSupplierBookingReportMutation = graphql(`
  mutation ResendSupplierBookingReport($id: ID!) {
    resendSupplierBookingReport(id: $id)
  }
`);

export const generateSupplierBookingReportMutation = graphql(`
  mutation GenerateSupplierBookingReport(
    $supplierId: ID!
    $month: Int!
    $year: Int!
  ) {
    generateSupplierBookingReport(
      supplier_id: $supplierId
      month: $month
      year: $year
    )
  }
`);
